import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M8.525 9.15a3.475 3.475 0 1 1 6.95 0 3.475 3.475 0 0 1-6.95 0ZM12 6.925a2.225 2.225 0 1 0 0 4.45 2.225 2.225 0 0 0 0-4.45Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      d="M9.475 15.8c0-.345.28-.625.625-.625h3.8a.625.625 0 1 1 0 1.25h-3.8a.625.625 0 0 1-.625-.625Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M9.033 1.875h5.934c.775 0 1.395 0 1.896.04.514.043.957.131 1.365.339a3.474 3.474 0 0 1 1.518 1.518c.208.408.296.851.338 1.365.041.501.041 1.12.041 1.896v9.934c0 .775 0 1.395-.04 1.896-.043.514-.131.957-.339 1.365a3.474 3.474 0 0 1-1.518 1.518c-.408.208-.851.296-1.365.338-.501.041-1.12.041-1.896.041H9.033c-.775 0-1.395 0-1.896-.04-.514-.043-.957-.131-1.365-.339a3.474 3.474 0 0 1-1.518-1.518c-.208-.408-.296-.851-.338-1.365-.041-.501-.041-1.12-.041-1.896V7.033c0-.775 0-1.395.04-1.896.043-.514.131-.957.339-1.365a3.475 3.475 0 0 1 1.518-1.518c.408-.208.851-.296 1.365-.338.501-.041 1.12-.041 1.896-.041ZM7.239 3.162c-.437.035-.697.103-.9.206a2.225 2.225 0 0 0-.971.972c-.103.202-.17.462-.206.899-.037.444-.037 1.013-.037 1.821v9.88c0 .808 0 1.377.037 1.821.035.437.103.697.206.9.213.418.553.758.972.971.202.103.462.17.899.206.444.037 1.013.037 1.821.037h5.88c.808 0 1.377 0 1.821-.037.437-.035.697-.103.9-.206a2.22 2.22 0 0 0 .971-.972c.103-.202.17-.462.206-.899.037-.444.037-1.013.037-1.821V7.06c0-.808 0-1.377-.037-1.821-.035-.437-.103-.697-.206-.9a2.225 2.225 0 0 0-.972-.971c-.202-.103-.462-.17-.899-.206-.444-.037-1.013-.037-1.821-.037H9.06c-.808 0-1.377 0-1.821.037Z"
      clip-rule="evenodd"
    />
  </svg>
`;
